import { assignNamespace } from "../../common/namespace-utils";
import { o_util } from "../../common/namespaces";
import * as mappers from "./head/mappers.js";
import { fetchOnexData, transformAndAssignOnexData } from "./head/fragment.js";
import { nexus } from "../../exports/nexus.js";

export * from "./head/mappers.js";

assignNamespace(o_util, "onex", {
  isOnexGroup: mappers.isOnexVariant,
  mapOnexGroup: mappers.mapOnexVariant,
  isOnexVariant: mappers.isOnexVariant,
  mapOnexVariant: mappers.mapOnexVariant,
  withOnex: mappers.withOnex,
  customAssignments: mappers.customAssignments,
});

/*                                                                             */
nexus().onex.assignments.set(transformAndAssignOnexData());

/*                                                                  */
if (import.meta.env.MODE !== "test") fetchOnexData();
